import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { SupplierCreatableInterface } from '../interfaces/supplier-creatable.interface';
import { SupplierDto } from './supplier.dto';

export class SupplierCreateDto
  extends IntersectionType(
    PickType(SupplierDto, ['name', 'email', 'phone']),
    PartialType(
      PickType(SupplierDto, [
        'externalId',
        'description',
        'contactInfo',
        'archived',
      ]),
    ),
  )
  implements SupplierCreatableInterface {}
